export const styles = {
    Block: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%'
    },
    BlockPadding: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        paddingLeft: 10,
        paddingRight: 10
    },
    BlockRaw: {
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    BlockCenter: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%'
    },
    BlockCenterPadding: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        paddingLeft: 10,
        paddingRight: 10
    },
    BlockRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'row',
        width: '100%'
    },
    BlockRowRaw: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'row',
    },
    BlockLeft: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: '100%'
    },
    BlockRight: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        flexDirection: 'column',
        width: '100%'
    },
    BlockMaxLarge: {
        // BLOK S MAX.PREDNASTAVENOU SIRKOU
        display: 'flex',
        flexDirection: 'column',
        maxWidth: global.screen_max,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    BlockMaxSmall: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 320,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    BlockMenu: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: global.menu_width,
        backgroundColor: global.theme_dark_blue
    },
    BlockMenuTitle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: global.menu_width,
        backgroundColor: '#B7CFFF'
    },
    BlockRound: {
        // BOX okrúhly pre faCheck
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        borderRadius: '50%',
        width: 40,
        height: 40,
        backgroundColor: global.theme_dark_red,
    },
    // ************************************************************************************************
    // BUTTONS
    // ************************************************************************************************
    Button: {
        color: global.theme_black,
        backgroundColor: global.theme_gray,
        fontSize: 15,
        width: 150,
        height: 36,
        textTransform: 'none',
        fontWeight: 'normal'
    },
    ButtonLight: {
        color: global.theme_white,
        background: global.theme_medium,
        fontSize: 15,
        width: 150,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonGray: {
        color: global.theme_black,
        background: global.theme_light_gray,
        fontSize: 15,
        width: 150,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonDark: {
        color: global.theme_white,
        background: global.theme_dark,
        fontSize: 15,
        width: 150,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonDarkSmall: {
        color: global.theme_white,
        background: global.theme_dark,
        fontSize: 13,
        width: 160,
        height: 28,
        borderRadius: 14,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonOutlined: {
        color: global.theme_black,
        //background: global.theme_dark,
        fontSize: 15,
        width: 160,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400',
        border: '1px solid #000000',
        letterSpacing: 0
    },
    ButtonIcon: {
        color: '#000000',
        fontSize: 14,
        width: 30,
        height: 30,
        borderRadius: 15,
        textTransform: 'none',
        fontWeight: '400',
        //backgroundColor: '#FFFFFF',
        border: '1px solid #B0B0B0'
    },
    ButtonOutlinedSmall: {
        color: global.theme_black,
        //background: global.theme_dark,
        fontSize: 13,
        width: 160,
        height: 28,
        borderRadius: 14,
        textTransform: 'none',
        fontWeight: '400',
        border: '1px solid #000000',
        letterSpacing: 0
    },
    ButtonGraySmall: {
        color: global.theme_black,
        background: global.theme_light_gray,
        fontSize: 13,
        width: 160,
        height: 28,
        borderRadius: 14,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonWhite: {
        color: global.theme_black,
        background: global.theme_white,
        //border: '1px solid #000000',
        fontSize: 14,
        width: 150,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonGreen: {
        color: global.theme_white,
        background: '#007700',
        fontSize: 15,
        width: 150,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonRed: {
        color: global.theme_white,
        background: global.theme_dark_red,
        fontSize: 15,
        width: 150,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonBlue: {
        color: global.theme_white,
        background: global.theme_blue,
        fontSize: 15,
        width: 150,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonRadius: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: global.theme_white,
        background: global.theme_dark_red,
        fontSize: 15,
        width: 36,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonRedSmall: {
        color: global.theme_white,
        background: global.theme_dark_red,
        fontSize: 14,
        width: 150,
        height: 36,
        borderRadius: 18,
        textTransform: 'none',
        fontWeight: '400'
    },
    ButtonLink: {
        color: global.theme_black,
        fontSize: 14,
        width: 150,
        height: 20,
        textTransform: 'none',
        fontWeight: 'normal'
    },
    ButtonFiles: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: global.theme_black,
        fontSize: 13,
        width: 75,
        height: 25,
        textTransform: 'none',
        fontWeight: 'normal',
    },
    ButtonDelete: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: global.theme_gray,
        color: global.theme_black,
        fontSize: 13,
        width: 120,
        height: 28,
        borderRadius: 14,
        textTransform: 'none',
        fontWeight: 'normal'
    },
    ButtonMenu: {
        color: global.theme_gray,
        backgroundColor: '#00000000',
        textTransform: 'none',
        fontWeight: 'normal',
        justifyContent: 'left',
        margin: 0,
        padding: 0,
        paddingLeft: 20,
        width: global.menu_width - 20,
        height: 34,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 17,
        borderBottomRightRadius: 17,
        fontSize: 12,
    },
    ButtonSettings: {
        marginBottom: 10,
        color: global.theme_medium_gray,
        backgroundColor: '#00000000',
        fontSize: 15,
        width: 195,
        height: 40,
        textTransform: 'none',
        fontWeight: 'normal',
        borderTopLeftRadius: 20,
        borderBottomLeftRadius: 20,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        marginLeft: 5
    },
    ButtonSettingsBig: {
        marginBottom: 0,
        color: global.theme_medium_gray,
        backgroundColor: '#00000000',
        fontSize: 15,
        width: 245,
        height: 60,
        textTransform: 'none',
        fontWeight: 'normal',
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        marginLeft: 5
    },
    ButtonSettingsMedium: {
        marginBottom: 0,
        color: global.theme_medium_gray,
        backgroundColor: '#00000000',
        fontSize: 15,
        width: 245,
        height: 50,
        textTransform: 'none',
        fontWeight: 'normal',
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        marginLeft: 5
    },
    ButtonFilter: {
        color: global.theme_white,
        background: global.theme_dark,
        fontSize: 14,
        width: 160,
        height: 28,
        borderRadius: 15,
        textTransform: 'none',
        fontWeight: '300',
        letterSpacing: 0.5
    },
    ButtonSelect: {
        color: global.theme_white,
        background: global.theme_blue,
        fontSize: 14,
        width: 160,
        height: 28,
        borderRadius: 15,
        textTransform: 'none',
        fontWeight: '300',
        letterSpacing: 0.5
    },


    Label: {
        fontSize: global.font_label,
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        color: global.theme_black,
        fontWeight: 'bold'
    },
    TextXXLarge: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xxlarge,
        color: global.theme_black,
    },
    TextXLarge: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xlarge,
        color: global.theme_black,
    },
    TextLarge: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_large,
        color: global.theme_black,
    },
    TextNormal: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_normal,
        color: global.theme_black,
    },
    TextMenu: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: 17,
        color: global.theme_black,
    },
    TextInput: {
        margin: 0,
        marginTop: 0,
        marginBottom: 3,
        fontSize: 14,
        color: global.theme_dark_gray,
        fontWeight: '400'
    },
    TextSmall: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_small,
        color: global.theme_black,
    },
    TextXSmall: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xsmall,
        color: global.theme_black,
    },
    TextTiny: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_tiny,
        color: global.theme_black,
    },
    TextXTiny: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xtiny,
        color: global.theme_black,
    },
    TextXXTiny: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xxtiny,
        color: global.theme_black,
    },
    TextXXXTiny: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: 8,
        color: global.theme_black,
    },
    TextTitle: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_xlarge,
        color: global.theme_black,
    },
    TextTinyMobile: {
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: global.font_tiny,
        color: global.theme_black,
    },
    ButtonPin: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 80,
        height: 80,
        borderRadius: '50%',
        border: '1px solid #FFFFFF',
        fontSize: global.font_xxlarge,
        color: global.theme_white,
        backgroundColor: global.theme_dark,
        cursor: 'pointer'
    },

    TextPin: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 16,
        height: 16,
        borderRadius: '50%',
        border: '1px solid #FFFFFF',
        fontSize: global.font_xxlarge,
        color: global.theme_white,
        backgroundColor: global.theme_dark
    },

    BorderTop:
    {
        borderTop: '1px solid ' + global.theme_gray
    },
    BorderBottom:
    {
        borderBottom: '1px solid ' + global.theme_gray
    },
    BorderTopBold:
    {
        borderTop: '3px solid ' + global.theme_gray
    },
    BorderBottomBold:
    {
        borderBottom: '3px solid ' + global.theme_gray
    },
    Border:
    {
        border: '1px solid ' + global.theme_gray
    },
    MenuLine:
    {
        marginTop: 0,
        marginBottom: 10,
        height: 1,
        justifySelf: 'center',
        alignSelf: 'center',
        width: global.menu_width - 70,
        borderTop: '1px solid ' + global.theme_dark_gray
    },
    TextDialogLabel: {
        fontWeight: '500',
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: 18,
        letterSpacing: 0.2,
        color: '#000000',
    },
    TextDialogSubLabel: {
        fontWeight: '300',
        margin: 0,
        marginTop: 0,
        marginBottom: 0,
        fontSize: 14,
        letterSpacing: 0.5,
        color: '#333333',
    },
};

